<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <router-link v-if="!serverError" :to="{ name: `${routePrefix}.edit`,params:{id} }"  class="btn btn-primary btn-sm" v-can:edit="permissionPrefix">
            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <input-number v-model="min_balance_to_keep" :options="{ id: 'min_balance_to_keep', transPrefix: `${transPrefix}.fields`, label: 'min_balance_to_keep', disabled: true }"/>
              <input-number v-model="min_amount" :options="{ id: 'min_amount', transPrefix: `${transPrefix}.fields`, label: 'min_amount', disabled: true }"/>
              <input-number v-model="max_amount" :options="{ id: 'max_amount', transPrefix: `${transPrefix}.fields`, label: 'max_amount', disabled: true }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { WITHDRAW_CONFIGS_SHOW as CRUD_ACTION_SHOW } from 'actions/withdraw_configs';
  const CRUD_CODE="withdraw_configs";
  export default {
    name: "WithdrawConfigShow",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: 'settings',
        id:this.$router.currentRoute.params.id,
        min_balance_to_keep: '',
        min_amount: '',
        max_amount: '',
        serverError: '',
        responseStatus:'',
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.min_balance_to_keep=response.data.data.minBalanceToKeep;
          this.min_amount=response.data.data.minAmount;
          this.max_amount=response.data.data.maxAmount;
        }).catch(error => {
          this.loading = false
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
    }
  };
</script>
